import { render } from "./TeacherPicker.vue?vue&type=template&id=28d5c6f6&scoped=true"
import script from "./TeacherPicker.vue?vue&type=script&lang=js"
export * from "./TeacherPicker.vue?vue&type=script&lang=js"

import "./TeacherPicker.vue?vue&type=style&index=0&id=28d5c6f6&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d5c6f6"]])

export default __exports__